export default __webpack_public_path__ + "static/media/AutoGravity.62a3525d.jpg";